<ion-header>
  <ion-toolbar>
    <ion-title>
      <ion-text color="secondary">
        <h3 class="ion-text-wrap" *ngIf="stepNumber <= 0">Agrega o escoge una dirección</h3>
        <h3 class="ion-text-wrap" *ngIf="stepNumber > 0">Confirma tu dirección</h3>
      </ion-text>
    </ion-title>
    <ion-buttons slot="end" *ngIf="stepNumber <= 0">
      <ion-button (click)="closeMap()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons  slot="start" *ngIf="stepNumber > 0">
      <ion-button (click)="firstStep()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">

  <ion-grid fixed>
    <!-- Listado de direcciones -->
    <ion-row [hidden]="stepNumber > 0">
      <ion-col size="12" class="ion-text-center">

        <!-- Elemento de busqueda -->
        <!-- <ion-searchbar placeholder="Ingresa una dirección" [(ngModel)]="searchingAddress" (ionChange)="updateSearchResults()"></ion-searchbar> -->

        <!-- Elemento inicial con ubicación actual -->
        <!-- <ion-item button (click)="selectSearchResult('actual')" *ngIf="location" [hidden]="suggestList.length > 0">
          <ion-icon slot="start" name="navigate" color="secondary"></ion-icon>
          <ion-label>
            <ion-text color="secondary">
              <h5><strong>Ubicación Actual</strong></h5>
              <h6>{{ location.address }}</h6>
            </ion-text>
          </ion-label>
        </ion-item> -->

        <!-- Listado de ubicaciones guardadas del usuario -->
        <ion-item button [hidden]="suggestList.length > 0" *ngFor="let item of userLocations">
          <ion-icon slot="start" name="location-outline" color="primary" (click)="secondStep({listSelected: item, close: true})"></ion-icon>
          <ion-label (click)="secondStep({listSelected: item, close: true})">
            <ion-text color="secondary">
              <h5><strong>{{ item.title }}</strong></h5>
              <h6>{{ item.address }} {{ item.addressComplement }}</h6>
            </ion-text>
          </ion-label>
          <ion-icon slot="end" name="trash" color="danger" (click)="removeLocation(item)"></ion-icon>
        </ion-item>

        <!-- Listado de resultados de la búsqueda de direcciones -->
        <!-- <ion-list [hidden]="suggestList.length === 0">
          <ion-item *ngFor="let suggest of suggestList" tappable (click)="selectSearchResult(suggest)">
            <ion-icon slot="start" name="pin" color="primary"></ion-icon>
            {{ suggest.description }}
          </ion-item>
          <div class="powered-wrapper">
            <img class="powered-img" src="assets/imgs/powered.png" alt="powered by google">
          </div>
        </ion-list> -->

        <br>
        <ion-button (click)="addLocation()" fill="outline" color="success">
          Agregar
        </ion-button>

      </ion-col>
    </ion-row>

    <!-- Mapa -->
    <ion-row [hidden]="stepNumber <= 0">
      <ion-col size="12">

        <!-- Formulario de Nueva dirección -->
        <ion-card class="ion-text-center">
          <!-- Mapa -->
          <!-- <ion-card-header class="ion-no-padding">
            <div #map id="map" class="select-position"></div>
          </ion-card-header> -->
          <!-- Detalles -->
          <ion-card-content *ngIf="newUserLocationSelected">
            <!-- Dirección -->
            <ion-item>
              <ion-input [(ngModel)]="location.address" placeholder="Dirección" color="secondary"></ion-input>
            </ion-item>
            <!-- Complemento dirección -->
            <!-- <ion-item>
              <ion-input [(ngModel)]="location.addressComplement" placeholder="Piso / # Oficina / Apto" color="secondary">
              </ion-input>
            </ion-item> -->
            <!-- Etiqueta para la ubicación -->
            <ion-radio-group [(ngModel)]="location.title">
          
              <ion-item>
                <ion-label>Hogar</ion-label>
                <ion-radio slot="start" value="Hogar"></ion-radio>
              </ion-item>
          
              <ion-item>
                <ion-label>Dispensario</ion-label>
                <ion-radio slot="start" value="Dispensario"></ion-radio>
              </ion-item>

              <ion-item>
                <ion-label>Centro médico</ion-label>
                <ion-radio slot="start" value="Centro médico"></ion-radio>
              </ion-item>
            </ion-radio-group>
            <!-- <ion-item>
              <ion-input [(ngModel)]="location.title"
                placeholder="Etiqueta (casa / oficina)" color="secondary">
              </ion-input>
            </ion-item> -->
            <!-- Botón -->
            <ion-button (click)="saveUserLocation()" *ngIf="!savingLocation">
              Guardar
            </ion-button>
            <ion-button fill="outline" *ngIf="savingLocation">
              Guardando <ion-spinner name="dots"></ion-spinner>
            </ion-button>
          </ion-card-content>
        </ion-card>

      </ion-col>
    </ion-row>

  </ion-grid>

</ion-content>